import { ROUTES } from 'global/constants';
import { getItemTypeMeta, ItemType } from 'items/models';
import {PartialBook} from 'labxchange-client';
import { detailUrlForEntity } from 'library/utils';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { WrappedMessage } from 'utils';
import libraryMessages from '../../displayMessages';
import discussionMessages from '../../../discussions/displayMessages';

interface LibraryBreadcrumbProps {
    itemType?: ItemType;
    book?: PartialBook;
}

export const LibraryBreadcrumb: React.FunctionComponent<LibraryBreadcrumbProps> = (props) => {

    let nested = null;
    // If the current item is part of a textbook, then we show the hierarchy as
    // library > book > {book title}
    if (props.book) {
        nested = (
            <>
                <NavLink to={{pathname: ROUTES.Library.HOME, search: `?t=ItemType:${ItemType.Book}`}}>
                    <WrappedMessage message={getItemTypeMeta(ItemType.Book).name} values={{count: 0}}/>
                </NavLink>
                &nbsp;&gt;{' '}
                <NavLink to={detailUrlForEntity({id: props.book.id, type: ItemType.Book})}>
                    {props.book.title}
                </NavLink>
            </>
        );
    } else if (props.itemType && props.itemType !== ItemType.Unknown) {
        nested = (
            <NavLink to={{pathname: ROUTES.Library.HOME, search: `?t=ItemType:${props.itemType}`}}>
                <WrappedMessage message={getItemTypeMeta(props.itemType!).name} values={{count: 0}}/>
            </NavLink>
        );
    }

    return (
        <div className='library-breadcrumb'>
            <NavLink to={ROUTES.Library.HOME}>
                <WrappedMessage message={libraryMessages.libraryCatalog}/>
            </NavLink>
            {nested &&
                <>
                    &nbsp;&gt;{' '}{nested}
                </>
            }
        </div>
    );
};


export interface NavLinkInfo {
    route: string;
    message: string;
}

interface DiscussionBreadcrumbProps {
    navLinksInfo: NavLinkInfo[];
}

export const DiscussionBreadcrumb: React.FunctionComponent<DiscussionBreadcrumbProps> = (props) => {
    return (
        <div className='discussions-breadcrumb'>
            <NavLink
                to={ROUTES.Community.DISCUSSIONS}>
                <WrappedMessage message={discussionMessages.discussionsHomeTitle}/>
            </NavLink>
            {props.navLinksInfo.map((navLinkInfo, i) => {
                return (
                    <React.Fragment key={i}>
                        &nbsp;&gt;{' '}
                        <NavLink to={navLinkInfo.route}>
                            {navLinkInfo.message}
                        </NavLink>
                    </React.Fragment>
                );
            })}
        </div>);
};
